import { Component, OnInit } from '@angular/core';
import { Meta, Title, DomSanitizer } from '@angular/platform-browser';
import { formatDate } from '@angular/common';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { APIService } from '../../services/api.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { SitemapComponent } from 'src/app/shared/sitemap/sitemap.component';

// const navigator = window.navigator as any;

@Component({
  selector: 'app-job-for-teachers',
  templateUrl: './app-job-for-teachers.component.html',
  styleUrls: ['./app-job-for-teachers.component.scss'],
  standalone: false,
})
export class JobForTeachersComponent implements OnInit {
  eventData: any = [];
  canShare = false;
  logoUrl: any;
  infiniteSlide = true;
  imageSize = {
    width: '80px',
    height: '80px',
    space: 12,
  };
  autoSlide = { interval: 1, stopOnHover: true };

  suggestedJobs = [
    {
      title: 'PGT English Teacher',
      school: 'Siddhant World School',
      location: 'Lucknow',
      postedDaysAgo: 7,
    },
    {
      title: 'PGT English Teacher',
      school: 'Peoples University',
      location: 'Bhopal',
      postedDaysAgo: 13,
    },
    {
      title: 'PGT English Teacher',
      school: 'Learners Zone',
      location: 'Rohtak',
      postedDaysAgo: 15,
    },
    {
      title: 'PGT English Teacher',
      school: 'Mr Durgesh',
      location: 'Etawah',
      postedDaysAgo: 10,
    },
  ];

  filters = {
    position: '',
    board: '',
    medium: '',
    level: '',
    subject: '',
    location: '',
    locationRange: '',
    salaryRange: '',
    datePosted: '',
    experience: '',
    employmentType: {
      fullTime: false,
      partTime: false,
      internship: false,
    },
  };

  constructor(
    public apiService: APIService,
    private router: Router,
    private title: Title,
    private meta: Meta,
    private sanitizer: DomSanitizer,
    private dialog: MatDialog,
    private deviceDetectorService: DeviceDetectorService
  ) {}

  ngOnInit(): void {
    console.log('router', this.router.url);
    const slug = this.getSlug(this.router.url);
    this.getLogo();
  }

  getLogo() {
    this.apiService.getSchoolLogo().subscribe((res: any) => {
      this.logoUrl = res;
    });
    if (this.logoUrl.length) {
      let thumbSize = 'h_280,w_360';
      let finalSize = 'h_800';

      this.logoUrl = this.logoUrl.map((img: any) => {
        img.thumbImage = this.transformImageSize(img.url, thumbSize);
        img.image = this.transformImageSize(img.url, finalSize);
        img.alt = '';
        img.title = '';
        return img;
      });
      // console.log('this.school.gallery after ', this.school.gallery);
    }
  }

  transformImageSize(url, size) {
    if (url && url.length && url.includes('cloudinary')) {
      const urlSplit = url.split('/upload/');
      return `${urlSplit[0]}/upload/${size}/${urlSplit[1]}`;
    }
    return url;
  }

  isMobile(): boolean {
    return this.deviceDetectorService.isMobile();
  }

  getSlug(url: string): string {
    const temp = url.split('?');
    const temp1 = temp[0].split('/');
    const lst = temp1.slice(-1)[0];
    return lst;
  }

  openDialog() {
    this.dialog.open(SitemapComponent, {
      width: this.isMobile() ? '90vw' : '800px',
      maxWidth: this.isMobile() ? '90vw' : '800px',
      height: this.isMobile() ? '90vh' : '600px',
      maxHeight: this.isMobile() ? '90vh' : '600px',
      restoreFocus: false,
      hasBackdrop: true,
      closeOnNavigation: true,
      disableClose: false,
    });
  }
}
